
import {IonContent, IonFooter, IonPage, IonItem, IonLabel, IonInput, modalController} from '@ionic/vue'
import {defineComponent, reactive, ref, computed, onUnmounted} from 'vue'
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'
import LeftTopLogo from '../components/Common/LeftTopLogo.vue'
import SimpleLoginModal from '@/components/Modal/SimpleLoginModal.vue'
import apiAuth from '@/api/auth'

const {sendVerificationSms, verifySms} = apiAuth()

export default defineComponent({
  components: {
    IonContent,
    IonFooter,
    IonInput,
    IonItem,
    IonLabel,
    IonPage,
    LeftTopLogo,
  },
  name: 'ForgotSimplePassword',
  setup() {
    const {commit, dispatch} = useStore()
    const router = useRouter()

    const step = ref<'identity' | 'sms'>('identity')
    const form = reactive({
      birthDate: '',
      name: '',
      phone: '',
    })
    const smsCode = ref('')
    const errorMessage = ref('')
    const remainSeconds = ref(0)
    const resendDisabled = ref(false)
    let timerInterval: any = null

    const isFormValid = computed(() => {
      return form.name && form.phone && form.birthDate
    })

    const timerText = computed(() => {
      const m = Math.floor(remainSeconds.value / 60)
      const s = remainSeconds.value % 60
      return `${m}:${s.toString().padStart(2, '0')}`
    })

    const startTimer = () => {
      remainSeconds.value = 300
      resendDisabled.value = true
      if (timerInterval) clearInterval(timerInterval)
      timerInterval = setInterval(() => {
        remainSeconds.value--
        if (remainSeconds.value <= 0) {
          clearInterval(timerInterval)
          resendDisabled.value = false
        }
      }, 1000)
    }

    const sendSms = async () => {
      errorMessage.value = ''
      const result = await sendVerificationSms(form.phone)
      if (result) {
        startTimer()
      } else {
        errorMessage.value = 'SMS 발송에 실패했습니다. 다시 시도해주세요.'
      }
    }

    const handleIdentitySubmit = async () => {
      if (!isFormValid.value) return
      errorMessage.value = ''

      try {
        const result = await dispatch('user/ACT_LOOKUP_UUID', {
          birthDate: form.birthDate,
          name: form.name,
          phone: form.phone,
        })

        if (result && result.uuid) {
          step.value = 'sms'
          await sendSms()
        } else {
          errorMessage.value = '등록되지 않은 사용자입니다'
        }
      } catch (error: any) {
        errorMessage.value = error?.response?.data?.message || '인증 실패. 다시 시도해주세요'
      }
    }

    const handleSmsVerify = async () => {
      errorMessage.value = ''

      const result = await verifySms(form.phone, smsCode.value)
      if (result.verified) {
        localStorage.setItem('simple_password_flag', 'false')
        commit('user/SET_SIMPLE_PASSWORD_FLAG', false)

        const modal = await modalController.create({
          backdropDismiss: false,
          component: SimpleLoginModal,
          cssClass: 'simple-login-modal',
          id: 'SimpleLoginModal',
          keyboardClose: true,
          mode: 'ios',
          swipeToClose: false,
        })
        await modal.present()
        const {data} = await modal.onDidDismiss()
        if (data === 'success') {
          router.replace('/tabs/home')
        }
      } else {
        errorMessage.value = result.error?.response?.data?.message || '인증번호가 일치하지 않습니다'
      }
    }

    onUnmounted(() => {
      if (timerInterval) clearInterval(timerInterval)
    })

    return {
      errorMessage,
      form,
      handleIdentitySubmit,
      handleSmsVerify,
      isFormValid,
      remainSeconds,
      resendDisabled,
      sendSms,
      smsCode,
      step,
      timerText,
    }
  },
})
